import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useTagStore } from "@/modules/tag/model/TagService";
import { computed, ref, watch } from "vue";

import Tag from "@/modules/tag/model/Tag";
import TagView from "@/modules/tag/components/Tag.vue";

import { TagFactory } from "@/modules/tag/model/TagFactory";

import { container } from "@/system/container";
import { TOKENS } from "@/system/tokens";


export default /*#__PURE__*/_defineComponent({
  __name: 'TagSearchField',
  props: ['modelValue'],
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;

const tagService = container.get(TOKENS.tagService);
const factory = new TagFactory()
const tagStore = useTagStore();
const options = ref();

const filteredTags = ref([]);
const selectedTags = ref([]);
const currentTags = ref([]);

// Use computed porperty and v-model instead




const tags =  computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  }
})

const onRemove = (tag: Tag) => {
  const index = tags.value.indexOf(tag)
  tags.value.splice(index, 1)
}


const filterFn = (val: string, update: any, abort: any) => {
  update(() => {
    const needle = val.toLowerCase();
    const values = tagStore.filterTags(needle);
    const v = values.filter((x) => {
      return tags.value.indexOf(x) === -1;
    });
    options.value = v;
  });
};

const createValue = (val: string, done: any) => {
  let existingTag = tagStore.findTag(val);
  if (existingTag) return;

  existingTag = tags.value.find((tag) => tag.title === val);
  if (existingTag) return;

  const tag = factory.createDefaultUnsavedTag();
  tag.title = val;
  if (tagService.isValid(tag)) done(tag);
};


return (_ctx: any,_cache: any) => {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, {
    modelValue: _unref(tags),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(tags) ? (tags).value = $event : null)),
    options: options.value,
    "use-input": "",
    multiple: "",
    label: "Search Tag",
    onFilter: filterFn,
    onNewValue: createValue,
    hint: "Basic filtering",
    rules: [ val => val.length >= 1 || 'At least one tag is required' ]
  }, {
    option: _withCtx((scope) => [
      _createVNode(_component_q_item, _normalizeProps(_guardReactiveProps(scope.itemProps)), {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_label, null, {
                default: _withCtx(() => [
                  _createVNode(TagView, {
                    tag: scope.opt
                  }, null, 8, ["tag"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1040)
    ]),
    "selected-item": _withCtx((scope) => [
      _createVNode(TagView, {
        tag: scope.opt,
        removable: true,
        onRemove: ($event: any) => (onRemove(scope.opt))
      }, null, 8, ["tag", "onRemove"])
    ]),
    _: 1
  }, 8, ["modelValue", "options", "rules"]))
}
}

})